import { RECORDINGS_ROUTE } from '../../../entities/history';
import { nil } from '../../../shared/lib';

export const sharedRouteHandlers = [{ route: RECORDINGS_ROUTE, saga: nil }];
